import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="specific--oas-map"
export default class extends Controller {
  static targets = ["map", "latInput", "lngInput", "mapsUrl"]
  static values = {
    apiKey: String,
    lat: Number,
    lng: Number,
  }

  connect() {
    if (!this.hasMapTarget) {
      console.error("Map target not found")
      return
    }
    if (!this.hasApiKeyValue) {
      console.error("Google Maps API key is missing")
      return
    }

    this.loadGoogleMaps()
  }

  loadGoogleMaps() {
    const script = document.createElement("script")
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}&libraries=marker`
    script.type = "module"
    script.async = true
    script.addEventListener("load", () => this.initMap())

    const mount = document.head || document.documentElement
    mount.appendChild(script)
    script.parentNode.removeChild(script)
  }

  initMap() {
    let lat = this.latValue
    let lng = this.lngValue
    let zoom = 14

    if (!lat || !lng) {
      // Default Werte setzen
      lat = 46.71494332537367
      lng = 8.079636157128704
      zoom = 8
    }

    const map = new google.maps.Map(this.mapTarget, {
      center: {lat: lat, lng: lng},
      zoom: zoom,
      mapId: 'DEMO_MAP_ID',
    })

    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: {lat: this.latValue, lng: this.lngValue},
    })

    map.addListener('click', (e) => {
      const clickedPosition = e.latLng
      const lat = clickedPosition.lat()
      const lng = clickedPosition.lng()

      marker.position = clickedPosition
      this.latInputTarget.value = lat
      this.lngInputTarget.value = lng
      this.updateMapsUrl(lat, lng)
    })
  }

  updateMapsUrl(lat, lng) {
    const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`
    this.mapsUrlTarget.textContent = mapsUrl
    this.mapsUrlTarget.href = mapsUrl
  }
}
